import type { Root } from 'react-dom/client'
import * as ReactDOM from 'react-dom/client'

import {
  signalPublishBootFailure,
  signalPublishBooted,
} from '~publish/boot/bootState'

import { MountFailureScreen } from './MountFailureScreen'

export const APP_ROOT_ID = 'root'

// Neutral on purpose: a pre-mount error can be an app bug on a current
// browser, not just an outdated one. Reserve browser-upgrade-only copy for
// callers with a real browser signal.
const DEFAULT_MESSAGE =
  'Something went wrong while loading Buffer. Refresh to try again, or try updating your browser.'

let mountFailureShown = false
let appMounted = false
let appRoot: Root | null = null

/**
 * Called by the entry immediately before `root.render()`, so a registered
 * root doubles as the "render has started" signal.
 */
export function registerAppRoot(root: Root): void {
  appRoot = root
  window['__publishRenderStarted'] = true
}

/** True once the entry has created the app root and called `render()`. */
export function hasAppRenderStarted(): boolean {
  return appRoot !== null
}

export function markAppMounted(): void {
  appMounted = true
  signalPublishBooted()
}

/** True once PublishRoot's first commit has happened. */
export function isAppMounted(): boolean {
  return appMounted
}

export function showMountFailure(message: string = DEFAULT_MESSAGE): void {
  if (mountFailureShown || appMounted || window['__publishBootFailureShown']) {
    return
  }

  mountFailureShown = true
  signalPublishBootFailure()

  if (appRoot) {
    appRoot.render(<MountFailureScreen message={message} />)
    return
  }

  const rootEl = document.getElementById(APP_ROOT_ID)
  if (!rootEl) {
    return
  }

  appRoot = ReactDOM.createRoot(rootEl)
  appRoot.render(<MountFailureScreen message={message} />)
}
